import { render, staticRenderFns } from "./Home2021.vue?vue&type=template&id=6f7cc336&scoped=true&"
import script from "./Home2021.vue?vue&type=script&lang=js&"
export * from "./Home2021.vue?vue&type=script&lang=js&"
import style0 from "./Home2021.vue?vue&type=style&index=0&id=6f7cc336&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7cc336",
  null
  
)

component.options.__file = "Home2021.vue"
export default component.exports